export interface EmploymentStatus {
  value: string | undefined;
  label: string;
}

export const EmploymentStatus: Array<EmploymentStatus> = [
  {
    value: undefined,
    label: "Select employment status",
  },
  {
    value: "unemployed",
    label: "Unemployed",
  },
  {
    value: "employed",
    label: "Employed",
  },
  {
    value: "self-employed",
    label: "Self Employed",
  },
];
